module.exports = __webpack_public_path__ + "img/9788925871646.c3fd3790.jpg";